module.exports = __webpack_public_path__ + "static/sport/game-1.64517fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport6/game-1.png
// module id = Bbd2
// module chunks = 0